module.exports = __webpack_public_path__ + "assets/img/922192.a4f027cd.jpg";